import { render } from "./LocationsDetailView.vue?vue&type=template&id=3b91364a&scoped=true"
import script from "./LocationsDetailView.vue?vue&type=script&lang=js"
export * from "./LocationsDetailView.vue?vue&type=script&lang=js"

import "./LocationsDetailView.vue?vue&type=style&index=0&id=3b91364a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b91364a"]])

export default __exports__